<template>
  <v-container fluid>
    <v-card class="card-rounded">
      <v-form @submit.prevent="saveEmpresa" ref="empresaForm" lazy-validation>
        <v-card-title>
          <span class="headline">Empresa</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" xl="4" lg="4" md="6" sm="12">
                <v-text-field
                  v-model="empresa.nome"
                  label="Nome"
                  :rules="nomeRules"
                  :loading="updateLoading"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="2" lg="2" md="6" sm="12">
                <v-text-field
                  v-model="empresa.cnpj"
                  v-mask="'###.###.###-##'"
                  label="Cnpj"
                  required
                  :loading="updateLoading"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="2" lg="2" md="6" sm="12">
                <v-text-field
                  v-model="empresa.telefone"
                  label="Telefone"
                  :loading="updateLoading"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="12" sm="12">
                <v-text-field
                  v-model="empresa.endereco"
                  :loading="updateLoading"
                  label="Endereço"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="6" sm="12">
                <v-text-field
                  v-model="empresa.email"
                  :loading="updateLoading"
                  label="Email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="6" sm="12">
                <v-text-field
                  v-model="empresa.site"
                  :loading="updateLoading"
                  label="Site"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="12" sm="12">
                <v-text-field
                  v-model="empresa.linkcadastro"
                  :loading="updateLoading"
                  label="Link cadastro app"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <span class="label-text">
                  Boletos
                </span>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                <v-text-field
                  v-model="empresa.minimosaque"
                  :loading="updateLoading"
                  label="Minimo para saque"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                <v-text-field
                  v-model="empresa.minimoboleto"
                  :loading="updateLoading"
                  label="Minimo boleto"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                <v-text-field
                  v-model="empresa.diasboleto"
                  :loading="updateLoading"
                  label="Dias boleto"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                <v-text-field
                  v-model="empresa.multaboleto"
                  :loading="updateLoading"
                  label="Multa boleto"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                <v-text-field
                  v-model="empresa.jurosboleto"
                  :loading="updateLoading"
                  label="Juros boleto"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                <v-text-field
                  v-model="empresa.diasvcto"
                  :loading="updateLoading"
                  label="Dias para o vencimento"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <span class="label-text">
                  Premium e indicações
                </span>
              </v-col>

              <v-col cols="6" xl="6" lg="6" md="12" sm="12">
                <v-row>
                  <v-col cols="12" xl="6" lg="6" md="12" sm="12">
                    <v-text-field
                      v-model="empresa.valorplano1"
                      :loading="updateLoading"
                      label="Valor premium"
                      type="number"
                      :rules="valorplano1rules"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xl="6" lg="6" md="12" sm="12">
                    <v-text-field
                      v-model="empresa.prazoindicacao1"
                      :loading="updateLoading"
                      label="Validade premium em meses"
                      :rules="validadepremium1rules"
                      type="number"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xl="6" lg="6" md="12" sm="12">
                    <v-text-field
                      v-model="empresa.indicacaoaceitaplano1"
                      :loading="updateLoading"
                      label="Valor indicação aceita"
                      :rules="indicacaoaceita1rules"
                      type="number"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xl="6" lg="6" md="12" sm="12">
                    <v-text-field
                      v-model="empresa.valorindicacao"
                      :loading="updateLoading"
                      label="Valor inidcação usuários free"
                      type="number"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="12" sm="12">
                <v-textarea
                  v-model="empresa.regrasindicacao1"
                  :loading="updateLoading"
                  label="Regras indicação"
                  outlined
                  rows="8"
                  :rules="regrasindicacao1rules"
                >
                </v-textarea>
              </v-col>

              <v-col cols="12">
                <span class="label-text">
                  Saques
                </span>
              </v-col>
              <v-col cols="3" xl="3" lg="3" md="6" sm="12">
                <v-text-field
                  v-model="empresa.taxa_ted"
                  :loading="updateLoading"
                  label="Taxa desconto TED"
                  type="number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3" xl="3" lg="3" md="6" sm="12">
                <v-text-field
                  v-model="empresa.perc_imposto"
                  :loading="updateLoading"
                  label="% Imposto"
                  type="number"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="updateLoading" color="primary" text type="submit">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import util from "@/service/util-service";

export default {
  data() {
    return {
      empresa: {},
      nomeRules: null,
      valorplano1rules: null,
      indicacaoaceita1rules: null,
      regrasindicacao1rules: null,
      validadepremium1rules: null,
      updateLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      dadosEmpresa: "empresa",
    }),
  },

  watch: {
    dadosEmpresa(v) {
      this.empresa = v;
    },
  },
  created() {
    this.createRules();
    this.loadEmpresa();
  },

  methods: {
    createRules() {
      this.nomeRules = [(v) => !!v || "Número é obrigatório"];
      this.valorplano1rules = [(v) => !!v || "Valor premium é obrigatório"];
      this.indicacaoaceita1rules = [
        (v) => !!v || "Indicação aceita é obrigatório",
      ];
      this.regrasindicacao1rules = [
        (v) => !!v || "Regras da indicação é obrigatório",
      ];
      this.validadepremium1rules = [
        (v) => !!v || "Validade premium é obrigatório",
      ];
    },
    loadEmpresa() {
      this.updateLoading = true;
      this.$store
        .dispatch("fetchEmpresa")
        .then((value) => {
          if (value) this.empresa = value;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.updateLoading = false;
        });
    },

    validateForm() {
      if (this.$refs.empresaForm.validate()) {
        return true;
      }
      return false;
    },
    saveEmpresa() {
      if (this.validateForm()) {
        this.updateLoading = true;
        this.$store
          .dispatch("updateEmpresa", this.empresa)
          .then((value) => {
            if (value.type == "error") {
              this.$store.dispatch("setNotification", {
                type: "error",
                text: value.msg,
              });
            } else {
              this.$store.dispatch("setNotification", {
                type: "success",
                text: value.msg,
              });
              this.loadEmpresa();
            }
          })
          .catch((err) => {
            this.$store.dispatch("setNotification", {
              type: "error",
              text: err,
            });
          })
          .finally(() => {
            this.updateLoading = false;
          });
      }
    },
  },
};
</script>
